import { IDefaultProjectTeamMaintenanceView } from '../../interfaces/idefault-project-team-maintenance-view';

export class DefaultProjectTeamMaintenanceViewBase {
  DefaultProjectTeamId: number;
  Description: string | null;
  AssetTeamId: number | null;
  AssetTeamCode: string;
  ProgramManagerEmployeeId: number | null;
  ProgramManagerTeamRoleId: number | null;
  ProgramManagerFullName: string | null;
  ProgramManagerTeamRole: string;
  ProjectManagerEmployeeId: number | null;
  ProjectManagerTeamRoleId: number | null;
  ProjectManagerFullName: string | null;
  ProjectManagerTeamRole: string;
  ProjectControlAnalystEmployeeId: number | null;
  ProjectControlAnalystTeamRoleId: number | null;
  ProjectControlAnalystFullName: string | null;
  ProjectControlAnalystTeamRole: string;
  ProjectEngineerEmployeeId: number | null;
  ProjectEngineerTeamRoleId: number | null;
  ProjectEngineerFullName: string | null;
  ProjectEngineerTeamRole: string;
  ProjectTechEmployeeId: number | null;
  ProjectTechTeamRoleId: number | null;
  ProjectTechFullName: string | null;
  ProjectTechTeamRole: string;
  ForceTeamUpdate: number;
  InUse: number;

  constructor(item?: IDefaultProjectTeamMaintenanceView) {
    if (item) {

      this.DefaultProjectTeamId = item.DefaultProjectTeamId;
      this.Description = item.Description;
      this.AssetTeamId = item.AssetTeamId;
      this.AssetTeamCode = item.AssetTeamCode;
      this.ProgramManagerEmployeeId = item.ProgramManagerEmployeeId;
      this.ProgramManagerTeamRoleId = item.ProgramManagerTeamRoleId;
      this.ProgramManagerFullName = item.ProgramManagerFullName;
      this.ProgramManagerTeamRole = item.ProgramManagerTeamRole;
      this.ProjectManagerEmployeeId = item.ProjectManagerEmployeeId;
      this.ProjectManagerTeamRoleId = item.ProjectManagerTeamRoleId;
      this.ProjectManagerFullName = item.ProjectManagerFullName;
      this.ProjectManagerTeamRole = item.ProjectManagerTeamRole;
      this.ProjectControlAnalystEmployeeId = item.ProjectControlAnalystEmployeeId;
      this.ProjectControlAnalystTeamRoleId = item.ProjectControlAnalystTeamRoleId;
      this.ProjectControlAnalystFullName = item.ProjectControlAnalystFullName;
      this.ProjectControlAnalystTeamRole = item.ProjectControlAnalystTeamRole;
      this.ProjectEngineerEmployeeId = item.ProjectEngineerEmployeeId;
      this.ProjectEngineerTeamRoleId = item.ProjectEngineerTeamRoleId;
      this.ProjectEngineerFullName = item.ProjectEngineerFullName;
      this.ProjectEngineerTeamRole = item.ProjectEngineerTeamRole;
      this.ProjectTechEmployeeId = item.ProjectTechEmployeeId;
      this.ProjectTechTeamRoleId = item.ProjectTechTeamRoleId;
      this.ProjectTechFullName = item.ProjectTechFullName;
      this.ProjectTechTeamRole = item.ProjectTechTeamRole;
      this.ForceTeamUpdate = item.ForceTeamUpdate;
      this.InUse = item.InUse;

    }
  }
}